import { render, staticRenderFns } from "./avg-session-popup.vue?vue&type=template&id=64ce5d30&scoped=true"
import script from "./avg-session-popup.ts?vue&type=script&lang=ts&external"
export * from "./avg-session-popup.ts?vue&type=script&lang=ts&external"
import style0 from "./avg-session-popup.scss?vue&type=style&index=0&id=64ce5d30&prod&lang=scss&scoped=true&external"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "64ce5d30",
  null
  
)

export default component.exports